export default __webpack_public_path__ + "623b55dfaf405d6e88377c0104601846.png";